import theme from "themes/Theme";
import { IconProps } from "./IconProps";

const SendChartIcon: React.FC<IconProps> = ({
  width = 11,
  height = 7,
  color = theme.palette.custom?.red,
}) => {
  return (
    <svg
      width={width}
      height={height}
      color={color}
      viewBox="0 0 11 7"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.05478 5.58273L10.8823 6.98242L9.68069 2.10186L8.18175 3.54084L5.76385 1.0222C5.68176 0.936691 5.56836 0.888357 5.44983 0.888357C5.33131 0.888357 5.21791 0.936691 5.13582 1.0222L3.36044 2.87155L0.749304 0.151615C0.582816 -0.0218101 0.307263 -0.0274339 0.133838 0.139054C-0.0395861 0.305542 -0.0452096 0.581095 0.121278 0.754519L3.04643 3.80155C3.12851 3.88706 3.24191 3.93539 3.36044 3.93539C3.47897 3.93539 3.59237 3.88706 3.67445 3.80155L5.44983 1.9522L7.55372 4.14374L6.05478 5.58273Z"
        fill={color}
      />
    </svg>
  );
};
export default SendChartIcon;
